<script>
import playerTools from '../tools/sketchfab/player'
import textureTools from '../tools/sketchfab/textures'
import sceneTools from '../tools/sketchfab/scene'
import materialTools from '../tools/sketchfab/materials'
import configure from '../tools/configurator/configure'
import configurator from './configurator'
import splash from './splash'

import store from '../store'

export default {
  name: 'player',
  components: {
    configurator,
    splash
  },
  computed: {
    sceneuid () {
      let currentScene = store.getters['scenes/getCurrentScene']
      return currentScene.sceneuid
    },
    loaded () {
      return store.getters['scenes/getsceneLoaded']
    }
  },
  mounted () {
    this.loadScene(this.sceneuid)
  },
  methods: {
    loadScene (sceneuid) {
      store.dispatch('scenes/setSceneLoading')
      store.commit('model/setProperty', {property: 'menuVisible', value: false})
      const playerSettings = store.getters['player/getState']
      playerTools.init('player__iframe')
      playerTools.loadScene(sceneuid, this, this.initViewer, playerSettings.player)
    },
    initViewer: function (scope) {
      scope.initTextures()
      scope.initDisplayItems()
      scope.setScene()

      // open the sidebar
      store.dispatch('scenes/setSceneLoaded')
      store.commit('model/setProperty', {property: 'menuVisible', value: true})
    },
    setScene () {
      configure.SetPostProcessing()
      configure.SetEnvironment()
      configure.SetBackground()
    },
    setInitialVisibility () {
      let state = store.getters['visibilitySingleList/getState']
      if (state.visibilityoptionssingle) {
        for (let opt of state.visibilityoptionssingle) {
          configure.SetVisibilitySingle(opt.visible, opt.objects, false)
        }
      }
      state = store.getters['visibilityGroupList/getState']
      if (state.visibilityoptionsgroup !== undefined) {
        for (let group of state.visibilityoptionsgroup) {
          let option = group.options.find(item => item.name === group.visible)
          if (option === null) {
            option = group.options[0]
          }
          configure.SetVisibilityGroup(group, option)
        }
      }
    },
    setInitialView () {
      const state = store.getters['viewsList/getState']
      if (state.views > 0) configure.setView(state.views[0])
    },
    setInitialMaterials () {
      const state = store.getters['materialList/getState']
      if (state.materials !== undefined) {
        for (let group of state.materials) {
          let option = group.options[0]
          if (group.visible !== undefined) {
            option = group.options.find(item => item.title === group.visible)
            if (option === null) {
              option = group.options[0]
            }
          }
          if (group.options.length > 0) {
            configure.SetMaterialOption(group, option)
          }
        }
      }
    },
    async initTextures () {
      textureTools.storeTextureList()
    },
    async initDisplayItems () {
      sceneTools.storeSceneGraph().then(() => {
        this.initMaterialItems()
        this.setInitialVisibility()
        this.setInitialView()
      }, (error) => {
        console.log(error)
      })
    },
    async initMaterialItems () {
      materialTools.storeMaterialList().then(() => {
        this.setInitialMaterials()
      }, (error) => {
        console.log(error)
      })
    }
  }
}
</script>

<template>
<div class="iframe">
  <splash class="splash" v-if="!loaded"/>
  <md-content v-if="!loaded"></md-content>
  <iframe class="player" :class="{'iframe__hidden': !loaded}" id="player__iframe"></iframe>
</div>
</template>

<style lang="scss" scoped>
.iframe {
  height:100%;
}
.player {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  opacity: 1;
  transition: opacity 2.0s ease;
  background: #ddd;
  position: relative;
  z-index:0;

  &.iframe__hidden {
    opacity: 0;
  }
}
.splash {
  z-index:10;
  position: fixed;
}
.md-content {
  width: 100%;
  height: 100%;
  z-index:5;
  position: relative;
}
</style>
